import { PayCommissionPreview_Read } from '@treadinc/horizon-api-spec';

export class PayCommissionPreview {
  constructor(
    private _gross_rate: PayCommissionPreview_Read['gross_rate'],
    private _percentage: PayCommissionPreview_Read['percentage'],
    private _net_rate: PayCommissionPreview_Read['net_rate'],
    private _rate_type: PayCommissionPreview_Read['rate_type'],
    private _status: PayCommissionPreview_Read['status'],
  ) {}

  public static parse(proto: PayCommissionPreview_Read) {
    return new PayCommissionPreview(
      proto.gross_rate,
      proto.percentage,
      proto.net_rate,
      proto.rate_type,
      proto.status,
    );
  }

  public get grossRate() {
    return this._gross_rate;
  }
  public get percentage() {
    return this._percentage;
  }
  public get netRate() {
    return this._net_rate;
  }
  public get rateType() {
    return this._rate_type;
  }
  public get status() {
    return this._status;
  }
}
